import { ChartSpline, CloudSun, Users} from "lucide-react";


export const ConservationStats = [
    {
        icon: ChartSpline,
        title: "85% yield increase",
        description: "Farmers using indigenous seeds report significant productivity improvements"
    },
    {
        icon: CloudSun,
        title: "Climate resilience",
        description: "Indigenous varieties show superior adaptation to changing weather patterns"
    },
    {
        icon: Users,
        title: "Community Empowerment",
        description: "Local seed banks established in 120+ villages across Kenya"
    }
]

export const BioStats = [
    {
        icon: ChartSpline,
        title: "Reduced cost of production",
        description: "Farmers save by accessing affordable fertilizers made using locally available materials."
    },
    {
        icon: ChartSpline,
        title: "Improved yields",
        description: "Biofertilizers enhance soil fertility for healthier crops."
    },
    {
        icon: ChartSpline,
        title: "Safer food",
        description: "Biopesticides reduce harmful residues."
    },
    {
        icon: ChartSpline,
        title: "Income generation",
        description: "Communities earn by selling packaged products."
    },
];

export const MarketStats = [
    {
        icon: Users,
        title: "Fair income",
        description: "Farmers earn more by selling directly"
    },
    {
        icon: Users,
        title: "Accessible markets",
        description: "Communities benefit from nearby organic produce"
    },
    {
        icon: Users,
        title: "Healthier diets",
        description: "Consumers access to safe and more nutritious food."
    },
    {
        icon: Users,
        title: "Transparency",
        description: "Food traceability builds trust among farmers and consumers"
    }
];

export const YouthAndWomenEmpowermentStats = [    
    {
        icon: Users,
        title: "Strengthening Seed Security, Sovereignty and Biodiversity",
        description: [
            "Over 10+ community seed banks established and led by empowered community members.",
            "More than 125 indigenous seed varieties preserved, regenerated, and shared.",
            "Youth and women now manage seed banks and ensure year-round seed access."
        ]
    },
    {
        icon: Users,
        title: "Expanded Knowledge and Climate Resilience",
        description: [
            "Over a thousand farmers trained in seed saving and agroecology — most of them youth and women.", "Increased adoption of agroecological practices that restore soils and protect biodiversity."
        ]
    },
    {
        icon: Users,
        title: "Economic Empowerment",
        description: [
            "Youth and women-led groups earning income through seed multiplication, indigenous crop value addition, and ecological enterprises like selling of biofertilizers and biopesticides.",
            "Better market access improving household incomes and promoting dignified livelihoods."
        ]
    },
    {
        icon: Users,
        title: "Reduced Dependency on Agrochemicals",
        description: [
            "Community training has significantly reduced reliance on harmful chemicals, improving ecosystems and safe food production"
        ]
    },
    {
        icon: Users,
        title: "Stronger Public Awareness and Policy Influence",
        description: [
            "Farmers involvement in public participation forums, anti-GMO campaigns, biopiracy, and the importance of farmer-managed seed systems."
        ]
    }
];

export const AdvocacyStats = [
    {
        icon: Users,
        title: "Seed sovereignity activism grow stronger",
        description: "Eden indigenous Seed farms took part in a historic high court ruling that declared criminalising seed sharing unconstitutional."
    },
    {
        icon: Users,
        title: "Strengthening seed sovereignity",
        description: "35+ community seed banks established, strengthening local seed security and resilience."
    },
    {
        icon: Users,
        title: "Preserving indigenous biodiversity",
        description: "125+ indigenous seed varieties preserved, regenerated, and shared across communities."
    },
    {
        icon: Users,
        title: "Increased public awareness",
        description: "Thousands of farmers trained in agroecology, seed saving, and climate-resilient farming."
    },
    {
        icon: Users,
        title: "Reducing harmful agrochemical dependancy",
        description: "Reduced dependency on harmful agrochemicals through community awareness and training."
    },
    {
        icon: Users,
        title: "GMO awareness and biosafety advocacy",
        description: "Greater public understanding of GMOs and the need for biosafety and transparency."
    },
    {
        icon: Users,
        title: "Improved livelihoods and local economies",
        description: "Improved household incomes through value addition and better market access for indigenous crops."
    },
    {
        icon: Users,
        title: "Food and nutritional security",
        description: "Enhanced food and nutrition security through wider cultivation and consumption of traditional foods."
    },
    {
        icon: Users,
        title: "Youth and women empowerment",
        description: "Empowered youth and women taking active roles in seed banking, community training, and ecological entrepreneurship."
    },
];